var render = function render(){var _vm=this,_c=_vm._self._c;return _c('resource-box',{attrs:{"name":_vm.title ? _vm.title : '每省公司分布top10'}},[_c('div',{staticClass:"bar-card",attrs:{"slot":"content"},slot:"content"},[_c('div',{ref:"barRef",staticClass:"chart-container"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }